import { render, staticRenderFns } from "./NovaOs.vue?vue&type=template&id=63efb012&"
import script from "./NovaOs.vue?vue&type=script&lang=js&"
export * from "./NovaOs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports